import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Output } from '@angular/core';
import { BaseModalComponent } from '../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../modal/modal.component';
import { take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '../../pipes/trans.pipe';

@Component({
  selector: 'app-alert-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
  ],
  templateUrl: './alert-modal.component.html',
  styleUrl: './alert-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertModalComponent extends BaseModalComponent<unknown> {

  @Output() onOk = new EventEmitter<void>();

  public static instance: AlertModalComponent;
  public text: string;

  public constructor() {
    super();

    AlertModalComponent.instance = this;
  }

  public okClick(): void {
    this.close();
    this.onOk.emit();
  }

  public static openAlertModal(title: string, text: string, destroyRef: DestroyRef, onOkCb?: () => void): void {
    AlertModalComponent.instance.title = title;
    AlertModalComponent.instance.text = text;
    AlertModalComponent.instance.onOk
      .pipe(
        take(1),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe(() => {
        if (onOkCb) {
          onOkCb();
        }
      });

    AlertModalComponent.instance.open();
  }
}
